import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useStepperControl } from "@/hooks/useStepperControl";
import { useEffect, useMemo } from "react";
import { UserData } from "../userdata";
import { Vistoria } from "../vistoria";
export function Home() {
    var _a = useStepperControl(), activeStep = _a.activeStep, moveThroughStep = _a.moveThroughStep;
    var steps = useMemo(function () {
        return [
            {
                title: "Cadastro",
                component: UserData,
            },
            {
                title: "Cadastro",
                component: Vistoria,
            },
        ];
    }, []);
    useEffect(function () {
        if (!activeStep || activeStep > steps.length - 1) {
            moveThroughStep(0);
        }
    }, [activeStep]);
    if (typeof activeStep === "boolean") {
        return null;
    }
    var Step = steps[activeStep].component;
    return (_jsx(_Fragment, { children: _jsx(Step, {}) }));
}
